import {Spin} from "antd";
import styles from "./index.module.scss";

const LoadingPage = ({height}) => {
    return (
        <>
            <div
                className={styles["loading-box"]}
                style={{height: height || "100vh"}}
            >
                <Spin size="large"/>
            </div>
        </>
    );
};

export default LoadingPage;
